var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-png';
                    var viewUrl = 'gfx/sprite.svg#view-icon-png';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 25 40',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };